import { api } from '@/redux/api';
import { RootState } from '@/redux/store';
import { ApplicationRole } from '@/types/application-role';
import { findById } from '@/utils/find-by-id';

export const selectRoleById =
  (roleId: number) =>
  (state: RootState): ApplicationRole => {
    const { data: roles } = api.endpoints.getRoles.select()(state);
    return (
      findById(roles ?? [], roleId) ?? {
        id: roleId,
        roleName: 'Unknown',
      }
    );
  };
